import styled from 'styled-components';
import { Typography } from '@mui/material';

const FieldsetStyled = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 20px;
`;

export default function Fieldset({ title, children }) {
  return (
    <FieldsetStyled>
      {title && <Typography variant="h6" gutterBottom>{title}</Typography>}
      {children}
    </FieldsetStyled>
  );
}